document.addEventListener('DOMContentLoaded', () => {
	const trigger = document.querySelector(
		'.wp-block-mavis-design-a-hairstyle__game-option--accessories',
	);
	const modal = document.querySelector('.mavis-modal');
	const close = modal && modal.querySelector('.mavis-modal__close');

	if (trigger && modal && close) {
		trigger.addEventListener('click', () => {
			modal.classList.add('is-active');
		});
		close.addEventListener('click', (e) => {
			e.stopPropagation();
			modal.classList.remove('is-active');
		});
	}
});
